
<div class="star-rating">
  <mat-icon
  *ngFor="let star of [1, 2, 3, 4, 5]"
  class="star"
  [ngStyle]="{ color: getStarColor(star) }"
  (mouseenter)="setHoveredRating(star)"
  (mouseleave)="setHoveredRating(null)"
  (touchstart)="setHoveredRating(star)"
  >
  {{ getStarType(star, reviews[0].rating) }}
</mat-icon>

  </div>

  <div class="review-count" [ngStyle]="{ color: getReviewTextColor() }">
    <span *ngIf="reviews.length > 0">
      ({{ reviews[0].content }} Reviews)
    </span>
    
  </div>
  <div class="rating-text" [class.visible]="hoveredRating !== null" [ngStyle]="{ color: getRatingTextColor(),paddingLeft: getDynamicPadding() + 'px',top: getDynamicTop() + 'px' }">
    {{ reviews[0].rating }}
  </div>
 